(function () {
  'use strict';

  angular.module('app').component('clientCommissionSeasonDetail', clientCommissionSeasonDetail());

  function clientCommissionSeasonDetail() {
    return {
      bindings: {
        clientCommissionSeason: '=',
        client: '=',
        mode: '<',
        priceLists: '=',
        onClientCommissionSeasonSaved: '&',
        onClientCommissionSeasonDeleted: '&',
        onClientCommissionSeasonCanceled: '&',
      },
      controller: ClientCommissionSeasonDetailComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/clients/components/client-commission-seasons/client-commission-season-detail/' +
        'client-commission-season-detail.component.html',
    };
  }

  ClientCommissionSeasonDetailComponent.$inject = [
    'CONFIGURATIONS',
    'UtilService',
    'ClientCommissionSeasonService',
    'ClientCommissionProductCategorySettingService',
    'ClientCommissionProductSettingService',
  ];

  function ClientCommissionSeasonDetailComponent(
    config,
    UtilService,
    ClientCommissionSeasonService,
    ClientCommissionProductCategorySettingService,
    ClientCommissionProductSettingService
  ) {
    var vm = this;

    vm.UtilService = new UtilService(vm);

    // vm.dateDisplay = config.DATE_DISPLAY;
    vm.dateDisplay = config.DATE_DISPLAY_SHORT;

    // Methods
    vm.editClientCommissionSeason = editClientCommissionSeason;
    vm.saveClientCommissionSeason = saveClientCommissionSeason;
    vm.cancel = cancel;

    vm.saveGeneralSettings = saveGeneralSettings;
    vm.toggleEditMode = toggleEditMode;

    vm.onProductCategorySettingsUpdated = onProductCategorySettingsUpdated;
    vm.onProductSettingsUpdated = onProductSettingsUpdated;

    vm.$onInit = function () {
      // console.log(vm.clientCommissionSeason);
      setGeneralSettings(vm.clientCommissionSeason.client_commission_general_settings);

      if (vm.clientCommissionSeason.id) {
        // View/Edit
        setItemOptions();
      } else {
        // New
        vm.saveButtonLabel = 'SAVE';
      }
    };

    function setItemOptions() {
      vm.saveButtonLabel = 'UPDATE';
    }

    vm.editClientCommissionSeason = editClientCommissionSeason;
    vm.changeClientCommissionSeasonStatus = changeClientCommissionSeasonStatus;
    vm.deleteClientCommissionSeason = deleteClientCommissionSeason;

    function editClientCommissionSeason() {
      vm.mode = 'edit';
    }

    function changeClientCommissionSeasonStatus(clientCommissionSeason) {
      ClientCommissionSeasonService.changeClientCommissionSeasonStatus(
        clientCommissionSeason,
        vm.client.id
      );
    }

    function deleteClientCommissionSeason(clientCommissionSeason) {
      var successCallback = function () {
        vm.onClientCommissionSeasonDeleted({ idSeasonDeleted: clientCommissionSeason.id });
      };

      ClientCommissionSeasonService.deleteClientCommissionSeason(
        clientCommissionSeason,
        vm.client.id,
        successCallback,
        {}
      );
    }

    // Save all settings for the client commission, for all price lists
    function saveClientCommissionSeason(isFormValid) {
      vm.formErrors = false;

      if (!isFormValid) {
        vm.formErrors = true;

        return;
      }

      var generalSettings = ClientCommissionSeasonService.groupGeneralSettingsByPriceList(
        vm.generalSettings
      );

      var productCategorySettings =
        ClientCommissionProductCategorySettingService.unGroupSettingsByProductCategory(
          vm.clientCommissionSeason.client_commission_product_category_settings
        );

      var productSettings = ClientCommissionProductSettingService.unGroupSettingsByProduct(
        vm.clientCommissionSeason.client_commission_product_settings
      );

      var params = {
        id: vm.clientCommissionSeason.id,
        client_commission_general_settings: generalSettings,
        client_commission_product_category_settings: productCategorySettings,
        client_commission_product_settings: productSettings,
        season_id: vm.clientCommissionSeason.season_id,
      };

      vm.sendingForm = true;
      ClientCommissionSeasonService.saveClientCommissionSeason(params, vm.client.id).then(function (
        response
      ) {
        if (response) {
          // Success
          if (vm.mode === 'create') {
            // Refresh object
            vm.clientCommissionSeason.id = response.id;
            vm.clientCommissionSeason.status = response.status;

            setGeneralSettings(response.client_commission_general_settings);

            setItemOptions();
          }

          vm.mode = 'view';

          vm.onClientCommissionSeasonSaved({ item: response });
        } else {
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    }

    function cancel() {
      vm.onClientCommissionSeasonCanceled({ mode: vm.mode });
      vm.mode = 'view';
    }

    // GENERAL SETTINGS

    function setGeneralSettings(clientCommissionGeneralSettings) {
      vm.generalSettings = ClientCommissionSeasonService.setGeneralSettings(
        clientCommissionGeneralSettings,
        vm.priceLists
      );
    }

    function saveGeneralSettings(generalSetting, isGeneralSettingFormValid) {
      vm.formErrors = false;

      if (!isGeneralSettingFormValid) {
        vm.formErrors = true;

        return;
      }

      if (generalSetting.editMode) {
        delete generalSetting.originalValues;
      }

      var generalSettings = generalSetting.settingsByPriceList;

      //console.log(generalSettings); return;
      vm.sendingForm = true;
      ClientCommissionSeasonService.saveGeneralSettings(
        generalSettings,
        vm.client.id,
        vm.clientCommissionSeason.id
      ).then(function (response) {
        if (response) {
          // Success
          vm.UtilService.itemListChanged(generalSetting.name);

          generalSetting.editMode = false;
        } else {
          vm.formErrors = true;
        }

        vm.sendingForm = false;
      });
    }

    function toggleEditMode(setting) {
      setting.editMode = !setting.editMode;

      if (!setting.editMode) {
        _restoreOriginalValues(setting);
      } else {
        setting.originalValues = angular.copy(setting);
      }
    }

    // Restore item original values - Edit mode
    function _restoreOriginalValues(setting) {
      setting.settingsByPriceList.forEach(function (priceListSetting) {
        setting.originalValues.settingsByPriceList.forEach(function (originalValue) {
          if (priceListSetting.id === originalValue.id) {
            priceListSetting[priceListSetting.percentage_type] =
              originalValue[priceListSetting.percentage_type];
            return;
          }
        });
      });
    }

    function onProductCategorySettingsUpdated() {
      //console.log('onProductCategorySettingsUpdated'); // what to do from here?
    }

    function onProductSettingsUpdated() {
      //console.log('onProductSettingsUpdated'); // what to do from here?
    }
  }
})();
